import { create } from 'zustand';
import type { Me } from '@/api/types';
import { normalizeMe } from '@/api/normalize';

export type AuthStatus = 'booting' | 'authed' | 'anon';

interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  me: Me | null;
  setSession: (token: string, me: Me) => void;
  setToken: (token: string) => void;
  setMe: (me: Me) => void;
  clear: () => void;
}

// Access token lives in memory only. Refresh token is an httpOnly cookie.
export const useAuth = create<AuthState>((set) => ({
  status: 'booting',
  accessToken: null,
  me: null,
  setSession: (accessToken, me) => set({ accessToken, me: normalizeMe(me), status: 'authed' }),
  setToken: (accessToken) => set({ accessToken }),
  setMe: (me) => set({ me: normalizeMe(me) }),
  clear: () => set({ accessToken: null, me: null, status: 'anon' }),
}));

/**
 * A guest account (docs/SPEC_TRY.md): invites and dates only, until it signs
 * in with Google (claimed guests too, until their dates move over).
 */
export const isGuest = (me: Pick<Me, 'role'> | null | undefined): boolean => me?.role === 'guest';
